import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export const OfflineIndicator = () => {
  const [offline, setOffline] = useState(
    typeof navigator !== "undefined" && navigator.onLine === false,
  );

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed z-50 left-1/2 -translate-x-1/2 top-[calc(env(safe-area-inset-top)+8px)] max-w-[92vw] rounded-md border bg-background shadow-md px-3 py-1.5 flex items-center gap-2 text-sm"
    >
      <WifiOff className="size-4 text-muted-foreground" />
      <span>You are offline. Showing cached app shell. Changes will not save.</span>
    </div>
  );
};
